export const untrailingSlashIt = str => {
  return str ? str.replace(/\/$/, "") : null
}

export const trailingSlashIt = str => {
  return str ? `${untrailingSlashIt(str)}/` : null
}
